/**
 * Gate 8 — Roughening
 *
 * Detects fake precision: confidence or numeric outputs expressed
 * to more decimal places than the inherent coarseness of the
 * estimate warrants. Overprecision signals either calibration
 * failure or template-generated output.
 *
 * Trip routes to a roughened stated_position with
 * reason='precision_reduced'. Unlike other gates, this does NOT
 * route to abstention — it returns a corrected stated_position.
 *
 * Max decimal places allowed: 2 (e.g. 0.85 is valid; 0.853 is not).
 */

const MAX_DECIMAL_PLACES = 2;

function countDecimalPlaces(n) {
  if (!Number.isFinite(n)) return 0;
  const str = n.toString();
  const dot = str.indexOf('.');
  return dot === -1 ? 0 : str.length - dot - 1;
}

function roughenConfidence(confidence) {
  return Math.round(confidence * 100) / 100;
}

/**
 * @param {import('../disciplineEnforcer.js').EnforcerEnvelope} envelope
 * @param {object} [_config]
 * @returns {import('../disciplineEnforcer.js').GateResult & { roughenedConfidence?: number }}
 */
export function checkRoughening(envelope, _config = {}) {
  if (envelope.confidence == null) {
    return { gateName: 'roughening', verdict: 'pass', reason: null, payload: { skipped: true } };
  }

  const dp = countDecimalPlaces(envelope.confidence);

  if (dp > MAX_DECIMAL_PLACES) {
    const roughenedConfidence = roughenConfidence(envelope.confidence);
    return {
      gateName: 'roughening',
      verdict: 'trip',
      reason: 'precision_reduced',
      payload: {
        originalConfidence: envelope.confidence,
        roughenedConfidence,
        decimalPlaces: dp,
        maxAllowed: MAX_DECIMAL_PLACES,
      },
      roughenedConfidence,
    };
  }

  return { gateName: 'roughening', verdict: 'pass', reason: null, payload: { decimalPlaces: dp } };
}
